import {createStore} from 'vuex'

import _isBoolean from 'lodash/isBoolean'
import _isArray from 'lodash/isArray'
import _isObject from 'lodash/isObject'
import _isUndefined from 'lodash/isUndefined'
import _isEqual from 'lodash/isEqual'
import _get from 'lodash/get'
import _has from 'lodash/has'

// import "@/assets/js/axios";
import {notifications} from "@/Utilities/Notifications";
import {Axios} from "axios";

const store = createStore({
    state() {
        return {
            apiUrl: 'http://127.0.0.1:8000/api/',
            axios: null,

            isAuthenticated: localStorage.getItem('user-token') || false,
            authToken: localStorage.getItem('user-token') || null,

            workspaces: null,
            profiles: null,

            currentWorkspace: null,
            currentViewChannel: null,

            mainChannelNames: ['company.relevant', 'company.not-relevant', 'assessment.report', 'assessment.benchmark'],
            channelNameUuidMappings: {},
            detailedChannels: {},


            openSponsorshipPopup: false,
            workspaceForSponsorshipPopup: null,

            openCopyWorkspacePopup: false,
            workspaceForCopyWorkspacePopup: null,

            openCopyCompanyPopup: false,
            companyForCompanyPopup: null,

            displayRecommendations: false,
            displaySearchResult: true,

            uiNotifications: [],

            editEntryMenu: null,

            globalNotifications: [],
        }
    },

    mutations: {
        setApiUrl(state, apiUrl) {
            state.apiUrl = new URL(apiUrl.replace(/\/$/, ''));
            if (state.axios instanceof Axios) {
                state.axios.defaults.baseURL = apiUrl.href;
            }
        },

        setAxios(state, axios) {
            state.axios = axios;
            axios.defaults.headers.common["Content-Type"] = "application/json";
            axios.defaults.headers.patch["Content-Type"] = "application/merge-patch+json";
            if (state.apiUrl instanceof URL) {
                axios.defaults.baseURL = state.apiUrl.href;
            }
        },

        setAuthenticationToken(state, authToken) {
            if (typeof authToken === 'string' && authToken.length > 0) {
                state.authToken = authToken;
                state.isAuthenticated = true;
                state.axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
            } else {
                state.authToken = null;
                state.isAuthenticated = false;
                delete state.axios.defaults.headers.common["Authorization"];
                // Reset all store key
            }
        },

        setOpenSponsorshipPopup(state, isOpen) {
            if (_isBoolean(isOpen)) {
                state.openSponsorshipPopup = isOpen;
            }
        },
        setWorkspaceForSponsorshipPopup(state, workspace) {
            if (_isObject(workspace) || workspace === null) {
                state.workspaceForSponsorshipPopup = workspace;
            }
        },

        setOpenCopyWorkspacePopup(state, isOpen) {
            if (_isBoolean(isOpen)) {
                state.openCopyWorkspacePopup = isOpen;
            }
        },
        setWorkspaceForCopyWorkspacePopup(state, workspace) {
            if (_isObject(workspace) || workspace === null) {
                state.workspaceForCopyWorkspacePopup = workspace;
            }
        },

        setOpenCompanyCopyPopup(state, isOpen) {
            if (_isBoolean(isOpen)) {
                state.openCopyCompanyPopup = isOpen;
            }
        },
        setCompanyForCopyCompanyPopup(state, company) {
            if (_isObject(company) || company === null) {
                state.companyForCompanyPopup = company;
            }
        },

        setDisplaySearchResult(state, isDisplay) {
            if (_isBoolean(isDisplay)) {
                state.displaySearchResult = isDisplay;
                state.displayRecommendations = !isDisplay;
            }
        },
        setDisplayRecommendations(state, isDisplay) {
            if (_isBoolean(isDisplay)) {
                state.displayRecommendations = isDisplay;
                state.displaySearchResult = !isDisplay;
            }
        },

        editMenuEntry(state, data) {
            state.editEntryMenu = data;
        },

        addNotification(state, notification) {
            let rawNotification = {
                type: notification.type,
                title: notification.title,
                body: notification.body,
            };

            state.uiNotifications.push({
                raw: rawNotification,
                timeOut: setTimeout(function () {
                    store.commit('removeNotification', rawNotification);
                }, notification.duration || 5000)
            });
        },
        removeNotification(state, notification) {
            let idx = state.uiNotifications.map(n => n.raw).findIndex((n) => _isEqual(n, notification));
            if (idx > -1) {
                clearTimeout(state.uiNotifications[idx].timeOut);
                state.uiNotifications.splice(idx, 1);
            }
        },


        setWorkspaces(state, workspaces) {
            state.workspaces = workspaces;
        },
        setCurrentWorkspace(state, workspace) {
            if (_isObject(workspace)) {
                state.currentWorkspace = workspace;
                state.channelNameUuidMappings = {};
                state.detailedChannels = {};
            }
        },

        setProfiles(state, profiles) {
            state.profiles = profiles;
        },

        addProfile(state, profile) {
            state.profiles[profile.workspaceIdentifier] = profile;
            state.profiles['length']++;
        },

        setNameUuidChannelMapping(state, channel) {
            state.channelNameUuidMappings[channel.name] = channel.uuid;
            state.channelNameUuidMappings[channel.uuid] = channel.name;
        },

        setDetailedChannel(state, channel) {
            state.detailedChannels[channel.name] = channel;
            // Tricks pour avoir le même object channel dans details et currentWorkspace
            let channelIdx = state.currentWorkspace.channels.findIndex(n => n.uuid === channel.uuid);
            if (channelIdx > -1) {
                state.currentWorkspace.channels[channelIdx] = channel;
            }
        },
        setCurrentWorkspaceChannel(state, channel) {
            let channelIdx = state.currentWorkspace.channels.findIndex(n => n.uuid === channel.uuid);
            if (channelIdx > -1) {
                state.currentWorkspace.channels[channelIdx] = channel;
            }
        },

        removeItemFromChannel(state, payload) {
            //payload = {channelUuid, item|itemUuid}
            const channel = payload.channel;

            if (_has(state.detailedChannels, channel.name)) {
                let itemUuid = null;
                if (null === (itemUuid = _get(payload, 'item.uuid', null))) {
                    itemUuid = _get(payload, 'itemUuid', null);
                }

                if (itemUuid !== null) {
                    const itemIdx = state.detailedChannels[channel.name].items.findIndex(n => n.uuid === itemUuid);
                    if (itemIdx > -1) {
                        state.detailedChannels[channel.name].items.splice(itemIdx, 1);
                        if (_has(state.detailedChannels[channel.name].counters, 'system.count')) {
                            state.detailedChannels[channel.name].counters['system.count']--;
                        }
                    }
                }

                return;
            }

            // Si le channel existe dans la liste des detailled, alors il s'agit du même objet channel dans
            // detailedChannel et currentWorkspace.channets[idx]
            let channelIdx = state.currentWorkspace.channels.findIndex(n => n.uuid === channel.uuid);
            if (channelIdx === -1) {
                return;
            }
            if (channelIdx > -1 && _has(state.currentWorkspace.channels[channelIdx].counters, 'system.count')) {
                state.currentWorkspace.channels[channelIdx].counters['system.count']--;
            }
        },


        setCurrentViewChannel(state, channelUuid) {
            if (null === channelUuid) {
                state.currentViewChannel = null;

                return;
            }

            state.currentViewChannel = state.channelNameUuidMappings[channelUuid];
        },

        setWorkspace(state, workspace) {
            if (!_has(state.workspaces, workspace.slug)) {
                state.workspaces['length']++;
            }
            state.workspaces[workspace.slug] = workspace;
        },

        setProfile(state, profile) {
            state.profiles[profile.workspaceIdentifier] = profile;
        },


        addChannelToWorkspace(state, channel) {
            state.currentWorkspace.channels.push(channel);
        },

        addInnovationProjectToCurrentWorkspace(state, innovationProject) {
            state.currentWorkspace.innovationProject = innovationProject;
        },

        setGlobalNotifications(state, notifications) {
            state.globalNotifications = notifications;
        },
        dismissGlobalNotification(state, notification) {
            state.globalNotifications = state.globalNotifications.filter((n) => n.token !== notification.token);
        },

        log(state, payload) {
            console.log(payload);
        }
    },

    getters: {
        notifications: state => state.uiNotifications.map(n => n.raw),

        getApiUrl(state) {
            return state.apiUrl;
        },

        isAuthenticated(state) {
            return state.isAuthenticated;
        },

        getAxios(state) {
            return state.axios
        },

        getMemberWorkspaces(state) {
            return state.workspaces;
        },

        getCurrentWorkspace(state) {
            return state.currentWorkspace;
        },

        getCurrentWorkspaceName(state) {
            return _get(state.currentWorkspace, 'name', null);
        },

        getCurrentWorkspaceSlug(state) {
            const slug = _get(state.currentWorkspace, 'slug', localStorage.getItem('current-workspace-slug'));

            if (slug) {
                return slug;
            }

            if (!slug && _get(state.workspaces, 'length')) {
                for (const workspacesKey in state.workspaces) {
                    if (workspacesKey !== 'length' && !state.workspaces[workspacesKey].archived) {
                        return state.workspaces[workspacesKey].slug
                    }
                }
            }

            return null;
        },

        getCurrentInnovation(state) {
            return _get(state.currentWorkspace, 'innovationProject', null);
        },


        getCurrentViewChannel(state) {
            return state.currentViewChannel;
        },
        getChannel(state) {
            return function (channelUuid) {
                return _get(state.currentWorkspace, 'channels', []).filter((channel) => {
                    return channel.uuid === channelUuid
                }).pop();
            }
        },
        getChannelUuid(state) {
            return function (channelName) {
                return _get(state.channelNameUuidMappings, channelName, null);
            }
        },
        getChannelName(state) {
            return function (channelUuid) {
                return _get(state.channelNameUuidMappings, channelUuid, null);
            }
        },
        getRelevantCompaniesChannelUuid(state) {
            return _get(state.channelNameUuidMappings, 'company.relevant', null);
        },
        getNotRelevantCompaniesChannelUuid(state) {
            return _get(state.channelNameUuidMappings, 'company.not-relevant', null);
        },
        getCompanyReportsChannelUuid(state) {
            return _get(state.channelNameUuidMappings, 'assessment.report', null);
        },
        getCompanyBenchmarksChannelUuid(state) {
            return _get(state.channelNameUuidMappings, 'assessment.benchmark', null);
        },


        isDetailedChannelLoaded(state) {
            return function (name) {
                return _get(state.detailedChannels, name, undefined) !== undefined;
            }
        },
        isInCustomCompanyChannel(state) {
            return state.currentViewChannel !== null && state.currentViewChannel.startsWith('company.custom');
        },
        isInNotRelevantChannel(state) {
            return state.currentViewChannel !== null && state.currentViewChannel === 'company.not-relevant';
        },
        isInRelevantChannel(state) {
            return state.currentViewChannel !== null && state.currentViewChannel === 'company.relevant';
        },
        isInReportChannel(state) {
            return state.currentViewChannel !== null && state.currentViewChannel === 'assessment.report';
        },


        getCompanyChannels(state) {
            return state.currentWorkspace.channels.filter((channel) => {
                return channel.name.startsWith('company.')
            })
        },
        getChannelCompanies(state) {
            return function (channelNane) {
                return _get(state.detailedChannels, channelNane, {'items': []}).items.map(n => n.referrerObject);
            };
        },
        getRelevantCompanies(state) {
            return _get(state.detailedChannels, 'company.relevant', {'items': []}).items.map(n => n.referrerObject);
        },
        getNotRelevantCompanies(state) {
            return _get(state.detailedChannels, 'company.not-relevant', {'items': []}).items.map(n => n.referrerObject);
        },
        getReports(state) {
            return _get(state.detailedChannels, 'assessment.report', {'items': []}).items.map(function (n) {
                return {
                    'referrerObject': n.referrerObject,
                    'companyId': _get(n, 'metas.companyId', null),
                    'innovationSlug': _get(n, 'metas.innovationSlug', null),
                }
            });
        },

        getCurrentMemberProfile(state) {
            return _get(state.profiles, state.currentWorkspace.slug, {
                "activeUpdatedAt": "2021-01-01T100:00:00+00:00",
                "createdAt": "2021-01-01T100:00:00+00:00",
                "initials": "UK",
                "fullName": "",
                "preferences": {},
                "locale": 'en_GB',
            });
        },
        getCurrentPublicMemberFullName(state) {
            return _get(state.profiles, state.currentWorkspace.slug, '');
        },

        getWorkspaceForSponsorshipPopup(state) {
            return state.workspaceForSponsorshipPopup;
        },

        getWorkspaceForCopyWorkspacePopup(state) {
            return state.workspaceForCopyWorkspacePopup;
        },

        getCurrentWorkspaceMemberProfile(state) {
            return function (uuid) {
                const profiles =  _get(state.currentWorkspace, 'profiles', null);
                if(profiles) {
                    return profiles.find((el) => el.uuid === uuid);
                }
            }
        },

        getWorkspaceMemberProfile(state) {
            return function (workspaceSlug) {
                return _get(state.profiles, workspaceSlug, null);
            }
        },

    },

    actions: {
        initApp(context, payload) {
            // Used mainly to restore app after a page reload
            if (context.state.isAuthenticated) { // Set the authentication header for axios
                context.commit('setAuthenticationToken', context.state.authToken);
            }
        },

        login(context, payload) {
            return context.state.axios
                .post('/login_check', payload)
                .then(function (response) {
                    const authToken = response.data.token;
                    const isCompany = _get(response.data, 'data.isCompany', false);

                    if(typeof isCompany !== 'boolean' || !isCompany) {
                        throw new Error('Invalid Account Profile');
                    }

                    if (typeof authToken === 'string' && authToken.length > 0) {
                        context.commit('setAuthenticationToken', authToken);
                        localStorage.setItem('user-token', authToken)
                        return;
                    }

                    throw new Error('Invalid Token');
                }.bind(this))
                .catch(function (error) {
                    localStorage.removeItem('user-token')
                    /// TODO: Display error message
                    throw error;
                });
        },

        logout({state, commit}) {
            commit('setAuthenticationToken', null);
            localStorage.removeItem('user-token');
            localStorage.removeItem('current-workspace-slug');

            state.workspaces = null;
            state.profiles = null;
            state.currentWorkspace = null;
            state.currentViewChannel = null;
            state.channelNameUuidMappings = {};
            state.detailedChannels = {};
            state.openSponsorshipPopup = false;
            state.workspaceForSponsorshipPopup = null;
            state.displayRecommendations = false;
            state.displaySearchResult = true;
            state.uiNotifications = [];
            state.editEntryMenu = null;
            state.globalNotifications = [];
        },

        registerCorporate(context, payload) {
            return context.state.axios
                .post('/account/register-corporate', payload)
                .then(function (response) {
                    return response;
                }.bind(this))
                .catch(function (error) {
                    throw error;
                });
        },

        async getUserWorkspaces(context) {
            if (!context.state.isAuthenticated) {
                return;
            }

            let workspaces = {length: 0};
            let profiles = {length: 0};
            let nextResultSetUrl = '/workspaces?active=true&archived=false';

            do {
                await context.state.axios
                    .get(nextResultSetUrl)
                    .then(function (response) {
                        let data = response.data;
                        if (data === undefined) {
                            nextResultSetUrl = null;
                            return;
                        }

                        if (_isArray(data['hydra:member'])) {
                            data['hydra:member'].forEach(function (element) {
                                workspaces[element.slug] = element;
                                workspaces['length']++;
                            });
                        }

                        nextResultSetUrl = !(_isUndefined(data['hydra:view']) || _isUndefined(data['hydra:view']['hydra:next'])) ? context.state.apiUrl.origin + data['hydra:view']['hydra:next'] : null;
                    })
                    .catch(function (error) {
                        // TODO: Make error management
                        context.commit('addNotification', notifications.getLoadingError('Workspaces'));
                        console.log(error)
                        throw error
                    });
            } while (nextResultSetUrl !== null)

            nextResultSetUrl = '/workspace/members';
            do {
                await context.state.axios
                    .get(nextResultSetUrl)
                    .then(function (response) {
                        let data = response.data;
                        if (data === undefined) {
                            nextResultSetUrl = null;
                            return;
                        }

                        if (_isArray(data['hydra:member'])) {
                            data['hydra:member'].forEach(function (element) {
                                if (workspaces[element.workspaceIdentifier] !== undefined) {
                                    profiles[element.workspaceIdentifier] = element;
                                    profiles['length']++;
                                }
                            });
                        }

                        nextResultSetUrl = !(_isUndefined(data['hydra:view']) || _isUndefined(data['hydra:view']['hydra:next'])) ? context.state.apiUrl.origin + data['hydra:view']['hydra:next'] : null;
                    })
                    .catch(function (error) {
                        // TODO: Make error management
                        context.commit('addNotification', notifications.getLoadingError('Workspaces'));
                        console.log(error)
                        throw error
                    });
            } while (nextResultSetUrl !== null)

            context.commit('setWorkspaces', workspaces);
            context.commit('setProfiles', profiles);
        },

        getCurrentWorkspace(context, slug) {
            return context.state.axios
                .get('/workspaces/' + slug, {})
                .then(function (response) {
                    context.commit('setCurrentWorkspace', response.data);
                    localStorage.setItem('current-workspace-slug', response.data.slug)
                    let channelIds = [];
                    for (const channel of response.data.channels) {
                        // if (context.state.mainChannelNames.indexOf(channel.name) > -1) {
                        channelIds.push(channel.uuid);
                        // }
                        context.commit('setNameUuidChannelMapping', channel);
                    }

                    if (channelIds.length > 0) {
                        context.dispatch('loadDetailedChannels', {channelIds: channelIds, workspaceSlug: slug});
                    }

                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getLoadingError('Current Workspace'));
                    console.log(error)
                    throw error
                });
        },

        getWorkspace(context, slug) {
            return context.state.axios
                .get('/workspaces/' + slug, {})
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getLoadingError('Error during workspace loading...'));
                    console.log(error)
                    throw error
                });
        },

        loadDetailedChannels(context, payload) {
            const uuidsFilter = '&' + payload.channelIds.map(n => `uuid[]=${n}`).join('&');

            return context.state.axios
                .get('/workspaces/' + payload.workspaceSlug + '/channels?' + uuidsFilter, {})
                .then(function (response) {
                    for (const channel of response.data['hydra:member']) {
                        context.commit('setDetailedChannel', channel);
                    }

                    return response.data['hydra:member'];
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getLoadingError('Channels'));
                    console.log(error)
                    throw error
                });
        },


        addCompanyToChannel(context, payload) {
            //payload = {channelUuid, company}
            let company = payload.company;
            const data = {
                "type": 300,
                "name": company.name,
                "description": null,
                "referrerObject": company.id
            };

            context.state.axios
                .post('/channels/' + payload.channelUuid + '/items', data, {})
                .then(function (response) {
                    if (response.status === 201 || response.status === 200) {
                        context.commit('setCurrentWorkspaceChannel', response.data);
                        context.commit('setDetailedChannel', response.data);
                        context.commit('addNotification', notifications.getCompanyAddedNotification(company.name, context.getters.getChannel(payload.channelUuid).label));
                    }
                })
                .catch(function (error) {
                    // TODO: Make error management
                    if (error.response.status === 409) {
                        context.commit('addNotification', notifications.getCompanyAlreadyAddedNotification(company.name));
                        return;
                    }
                    console.log(error)
                    throw error;
                });
        },

        removeCompanyFromChannel(context, payload) {
            // TODO: Possibly delete all reject votes for the channel, for the moment we keep all votes
            //payload = {channelUuid, company}
            const channelName = context.getters.getChannelName(payload.channelUuid);
            const item = context.state.detailedChannels[channelName].items.find(n => n.referrerObject === payload.company.id);

            if (item === undefined) {
                return;
            }

            return context.state.axios
                .delete(`/channels/${payload.channelUuid}/items/${item.uuid}`, {})
                .then(function (response) {
                    context.commit('removeItemFromChannel', {
                        channel: context.state.detailedChannels[channelName],
                        item: item
                    });
                    context.commit('addNotification', notifications.getCompanyRemovedNotification(payload.company.name));
                })
                .catch(function (error) {
                    // TODO: Make error management
                    console.log(error)
                    if (error.response.status === 404) {
                        context.commit('addNotification', notifications.getCompanyRemovedNotification(payload.company.name));
                        return;
                    }
                    console.log(error)
                    throw error;
                });
        },


        createWorkspace(context, data) {
            let workspaceData = {
                name: _get(data, 'name', 'Project ' + (context.state.workspaces.length + 1)),
                description: _get(data, 'name', 'The project number ' + (context.state.workspaces.length + 1)),
                options: {
                    "theme": "light",
                    "primary_channels_order": ["company", "assessment", "document", "topic", "search"]
                },
            };

            return context.state.axios
                .post('/workspaces', workspaceData, {})
                .then(function (response) {
                    if (response.status === 201 || response.status === 200) {
                        context.commit('setWorkspace', response.data);
                        context.commit('addNotification', notifications.getCreatedWorkspaceNotification(workspaceData.name));

                        context.state.axios
                            .get(`/workspace/members/${response.data.members[0].uuid}`)
                            .then(function (response) {
                                const memberData = response.data;
                                context.commit('addProfile', memberData);
                            });
                    }

                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getCreatedWorkspaceErrorNotification(workspaceData.name));
                    console.log(error)
                    throw error
                });
        },


        copyWorkspace(context, data) {
            let workspace = null;
            let workspaceSlug = _get(data, 'workspaceSlug', null);
            if(workspaceSlug === null) {
                workspace = _get(data, 'workspace', null);
                if(workspace !== null) {
                    workspaceSlug = workspace.slug;
                } else {
                    context.commit('addNotification', notifications.getCopyWorkspaceErrorNotification());
                    return;
                }
            }

            if(null === workspace) {
                workspace = context.state.workspaces[workspaceSlug];
            }

            let copyData = {
                name: _get(data, 'name', workspace.name + ' (copy)'),
                userPreferences: _get(data, 'userPreferences', true),
                innovation: _get(data, 'innovation', true),
                groups: _get(data, 'groups', true),
                channels: _get(data, 'channels', true),
                channelElements: _get(data, 'channelElements', true),
                attachments: _get(data, 'attachments', true),
            };

            return context.state.axios
                .post(`/workspaces/${workspaceSlug}/copy`, copyData, {})
                .then(function (response) {
                    if (response.status === 201 || response.status === 200) {
                        context.commit('setWorkspace', response.data);
                        context.commit('addNotification', notifications.getCopiedWorkspaceNotification(copyData.name));

                        context.state.axios
                            .get(`/workspace/members/${response.data.members[0].uuid}`)
                            .then(function (response) {
                                const memberData = response.data;
                                context.commit('addProfile', memberData);
                            });
                    }

                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getCopiedWorkspaceErrorNotification(copyData.name));
                    console.log(error)
                    throw error
                });
        },


        copyCompanyIntoChannel(context, data) {
            let workspace = null;
            let workspaceSlug = _get(data, 'workspaceSlug', null);
            let targetWorkspace = _get(data, 'targetWorkspace', null);
            let targetChannel = _get(data, 'targetChannel', null);
            let targetCompany = _get(data, 'company', null);
            let referralChannel = _get(data, 'channel', null);

            if(workspaceSlug === null) {
                workspace = _get(data, 'workspace', null);
                if(workspace !== null) {
                    workspaceSlug = workspace.slug;
                } else {
                    context.commit('addNotification', notifications.getCopyWorkspaceErrorNotification());
                    return;
                }
            }

            if(null === workspace) {
                workspace = context.state.workspaces[workspaceSlug];
            }


            let copyData = {
                referralChannel: _get(referralChannel, 'uuid', null),
                targetCompany: _get(targetCompany, 'id', null),
                targetWorkspace: _get(targetWorkspace, 'slug', null),
                targetChannel: _get(targetChannel, 'uuid', null),
                attachments: _get(data, 'attachments', true),
            };

            return context.state.axios
                .post(`/workspaces/${workspaceSlug}/copy-company`, copyData, {})
                .then(function (response) {
                    if (response.status === 201 || response.status === 200) {
                        context.commit('addNotification', notifications.getCopiedCompanyNotification(targetWorkspace.name, targetCompany.name, targetChannel.label));
                    }

                    return response.data;
                })
                .catch(function (error) {
                    if (error.response.status === 409) {
                        context.commit('addNotification', notifications.getCopyCompanyAlreadyAddedErrorNotification(targetCompany.name));
                        return;
                    }

                    // TODO: Make error management
                    context.commit('addNotification', notifications.getCopiedWorkspaceErrorNotification(copyData.name));
                    console.log(error)
                    throw error
                });
        },


        renameWorkspace(context, data) {
            // Use in the context of workspace renaming by the workspace owner
            // Otherwise use editUserProfile
            const enrichedData = {
                ...data,
                noNotification: true,
            };
            context
                .dispatch("editWorkspace", enrichedData)
                .then(() => context.dispatch("editUserProfile", enrichedData))
                .then(() => context.commit('addNotification', _get(enrichedData, 'notification', notifications.getEditedWorkspaceNotification(enrichedData.name))));
        },

        editWorkspace(context, data) {
            const noNotification = _get(data, 'noNotification', false);
            let workspace = context.state.workspaces[data.workspaceSlug];
            let workspaceData = {
                name: _get(data, 'workspaceName', workspace.name),
                description: _get(data, 'description', workspace.description),
                options: _get(data, 'options', workspace.options),
                locale: _get(data, 'locale', workspace.locale),
                archived: _get(data, 'archived', workspace.archived),
            };

            return context.state.axios
                .put('/workspaces/' + data.workspaceSlug, workspaceData, {})
                .then(function (response) {
                    context.commit('setWorkspace', response.data);
                    if (!noNotification) {
                        context.commit('addNotification', _get(data, 'notification', notifications.getEditedWorkspaceNotification(workspaceData.name)));
                    }
                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getEditedWorkspaceErrorNotification(workspaceData.name));
                    console.log(error)
                    throw error;
                });
        },

        editUserProfile(context, payload) {
            const noNotification = _get(payload, 'noNotification', false);
            let profile = context.state.profiles[payload.workspaceSlug];
            let preferencesData = {
                workspaceAlias: _get(payload, 'workspaceName', profile.workspaceAlias),
                autoMarkedAsRelevant: _get(payload, 'autoMarkedAsRelevant', profile.preferences.autoMarkedAsRelevant),
            };

            return context.state.axios
                .put(`/workspace/members/${profile.uuid}/preferences`, preferencesData, {})
                .then(function (response) {
                    context.commit('setProfile', response.data);
                    if (!noNotification) {
                        context.commit('addNotification', _get(profile, 'notification', notifications.getEditedProfileNotification()));
                    }
                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getEditedProfileErrorNotification());
                    console.log(error)
                    throw error
                });
        },

        createInnovationProject(context, payload) {
            const workspaceSlug = _get(payload, 'workspace.slug', _get(payload, 'workspaceSlug', null));
            if (workspaceSlug === null) {
                context.commit('addNotification', notifications.getErrorNotification('Action not completed', 'Some data are missing.'));
                throw new Error()
            }

            const data = {
                "innovationName": _get(payload, 'innovationName', null),
                "innovationWebsite": _get(payload, 'innovationWebsite', null),
                "innovationCountry": _get(payload, 'innovationCountry', null),
                "businessArea": _get(payload, 'businessArea', null),
                "globalTrends": _get(payload, 'globalTrends', []),
                "priority1": _get(payload, 'firstPriority', null),
                "priority2": _get(payload, 'secondPriority', null),
                "additionalKPIs": _get(payload, 'additionalKPIs', []),
                "idealFormatForYourInnovation": _get(payload, 'idealFormats', []),
                "targetedSocialImpact": _get(payload, 'targetedSocialImpact', null),
                "strengthOfYourInnovation": _get(payload, 'innovationStrengths', []),
                "dreamOpenInnovationScenario": _get(payload, 'dreamScenario', null)
            };

            return context.state.axios
                .post(`/workspaces/${workspaceSlug}/innovation-project`, data, {})
                .then(function (response) {
                    const workspace = response.data;
                    context.commit('setWorkspace', workspace);
                    if (context.state.currentWorkspace.uuid === workspace.uuid) {
                        context.commit('addInnovationProjectToCurrentWorkspace', workspace.innovationProject)
                    }
                    context.commit('addNotification', _get(payload, 'notification', notifications.getCreatedInnovationProjectNotification(data.innovationName)));

                    return workspace;
                }.bind(this))
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getCreatedInnovationProjectErrorNotification(data.innovationName));
                    console.log(error)
                    throw error
                });
        },

        editInnovationProject(context, payload) {
            const workspaceSlug = _get(payload, 'workspace.slug', _get(payload, 'workspaceSlug', null));
            if (workspaceSlug === null) {
                context.commit('addNotification', notifications.getErrorNotification('Action not completed', 'Some data are missing.'));
                throw new Error()
            }

            const data = {
                "innovationName": _get(payload, 'innovationName', null),
                "innovationWebsite": _get(payload, 'innovationWebsite', null),
                "innovationCountry": _get(payload, 'innovationCountry', null),
                "businessArea": _get(payload, 'businessArea', null),
                "globalTrends": _get(payload, 'globalTrends', []),
                "priority1": _get(payload, 'firstPriority', null),
                "priority2": _get(payload, 'secondPriority', null),
                "additionalKPIs": _get(payload, 'additionalKPIs', []),
                "idealFormatForYourInnovation": _get(payload, 'idealFormats', []),
                "targetedSocialImpact": _get(payload, 'targetedSocialImpact', null),
                "strengthOfYourInnovation": _get(payload, 'innovationStrengths', []),
                "dreamOpenInnovationScenario": _get(payload, 'dreamScenario', null)
            };

            return context.state.axios
                .put(`/workspaces/${workspaceSlug}/innovation-project`, data, {})
                .then(function (response) {
                    const workspace = response.data;
                    context.commit('setWorkspace', workspace);
                    context.commit('addNotification', _get(payload, 'notification', notifications.getEditedInnovationProjectNotification(data.innovationName)));

                    return workspace;
                }.bind(this))
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getEditedInnovationProjectErrorNotification(data.innovationName));
                    console.log(error)
                    throw error
                });
        },

        createReport(context, payload) {
            let reportData = {
                companySlug: _get(payload, 'company.id', null),
                innovationSlug: _get(payload, 'innovation.slug', null),
            };

            if (reportData.companySlug === null) {
                context.commit('addNotification', notifications.getErrorNotification('Action not completed', 'You have no selected a company.'));
                throw new Error()
            }

            if (reportData.innovationSlug === null) {
                context.commit('addNotification', notifications.getErrorNotification('Action not completed', 'You have not defined an innovation project.'));
                throw new Error()
            }

            return context.state.axios
                .post('/reports', reportData, {})
                .then(function (response) {
                    if (response.status === 201 || response.status === 200) {
                        context.commit('addNotification', notifications.getSuccessNotification('Your request has been sent.'));

                        const reportItemData = {
                            "type": 100,
                            "name": '[' + _get(payload, 'company.name', '') + '] [' + _get(payload, 'innovation.innovationName', '') + ']',
                            "description": '\'' + _get(payload, 'company.name', '') + '\' report for \'' + _get(payload, 'innovation.innovationName', '') + '\' innovation',
                            "referrerObject": response.data.token,
                            "metas": {
                                companyId: _get(payload, 'company.id', ''),
                                innovationSlug: _get(payload, 'innovation.slug', ''),
                            }
                        };

                        context.state.axios
                            .post(`/channels/${payload.channelUuid}/items`, reportItemData, {})
                            .then(function (response) {
                                if (response.status === 201 || response.status === 200) {
                                    context.commit('setCurrentWorkspaceChannel', response.data);
                                    context.commit('setDetailedChannel', response.data);
                                }
                            })
                            .catch(function (error) {
                                // TODO: Make error management
                                context.commit('addNotification', notifications.getErrorNotification('An error occurred.', "Retry later please."));
                                console.log(error)
                                throw error;
                            });
                    }

                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    if(error.response.status === 403) {
                        context.commit('addNotification', notifications.getErrorNotification('Impossible to process the request', _get(error.response.data, 'message', error.response.data['hydra:description'])));
                    } else {
                        context.commit('addNotification', notifications.getErrorNotification('An error occurred.', error.response.data.message));
                    }
                    console.log(error)
                    throw error;
                });
        },


        createCompanyChannel(context, data) {
            let companyChannel = context.state.currentWorkspace.channels.filter((channel) => {
                return channel.name.startsWith("company");
            });

            let customCompanyChannelCount = companyChannel.filter((channel) => {
                return channel.name.startsWith("company.custom.");
            }).length;

            let companyChannelCount = companyChannel.length + 1;

            let channelData = {
                workspace: context.state.currentWorkspace.slug,
                name: 'company.custom.' + companyChannelCount,
                type: 200,
                label: _get(data, 'channelName', null),
                description: _get(data, 'description', 'The custom company channel number ' + companyChannelCount),
                visibility: 2,
                rights: 7,
                sortOrder: customCompanyChannelCount === 0 ? 11 : (customCompanyChannelCount + 10),
                counters: {},
            };

            return context.dispatch('createChannel', channelData).then(function (channelResponse) {
                context.commit('addNotification', notifications.getCreatedChannelNotification(channelData.label));
                return channelResponse;
            });
        },

        createChannel(context, data) {
            let channelData = {
                workspace: _get(data, 'workspace', null),
                name: _get(data, 'name', null),
                label: _get(data, 'label', null),
                type: _get(data, 'type', null),
                description: _get(data, 'description', null),
                sortOrder: _get(data, 'sortOrder', null),
                counters: _get(data, 'counters', {}),
                visibility: _get(data, 'visibility', null),
                rights: _get(data, 'rights', null),
            };

            return context.state.axios
                .post('/channels', channelData, {})
                .then(function (response) {
                    context.commit('addChannelToWorkspace', response.data);
                    context.commit('setDetailedChannel', response.data);
                    context.commit('setNameUuidChannelMapping', response.data);

                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getCreatedChannelErrorNotification(channelData.label));
                    console.log(error)
                    throw error
                });
        },


        loadCompanyPosts(context, payload) {
            const workspace = _get(context.state.currentWorkspace, 'slug', null);
            const channel = _get(payload, 'channel.uuid', null);
            const company = _get(payload, 'company.id', null);

            let filters = ['post.state=1', 'isReply=false'];
            if (null !== workspace) {
                filters.push(`workspaceSlug=${workspace}`);
            }
            if (null !== channel) {
                filters.push(`channelUuid=${channel}`);
            } else {
                filters.push('exists[channel]=false');
            }
            if (null !== company) {
                filters.push(`companySlug=${company}`);
            } else {
                filters.push('exists[company]=false');
            }

            return context.state.axios
                .get('/workspace/company-posts?' + filters.join('&'), {})
                .then(function (response) {
                    let companyPosts = response.data['hydra:member'];

                    // let processedCompanyPosts = [];
                    // for (const companyPost of companyPosts) {
                    //     if (companyPost.post.repliedTo !== null) {
                    //         let parentCompanyPost = companyPosts.find((n) => n.post.uuid === companyPost.post.repliedTo.uuid);
                    //         if (parentCompanyPost !== undefined) {
                    //             const index = parentCompanyPost.post.replies.findIndex((n) => n.uuid === companyPost.post.uuid);
                    //             if (index !== -1) {
                    //                 parentCompanyPost.post.replies[index] = companyPost;
                    //             }
                    //         }
                    //         continue;
                    //     }
                    //
                    //     processedCompanyPosts.push(companyPost);
                    // }

                    return companyPosts;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getLoadingError('Posts'));
                    console.log(error)
                    throw error
                });
        },

        createCompanyPost(context, payload) {
            let data = {
                workspace: _get(context.state.currentWorkspace, 'slug', null),
                channel: _get(payload, 'channel.uuid', null),
                company: _get(payload, 'company.id', null),
                content: _get(payload, 'content', ''),
                replyTo: _get(payload, 'replyTo', null),
            }

            return context.state.axios
                .post('/workspace/company-posts', data, {})
                .then(function (response) {
                    let post = response.data;
                    // context.commit('addNotification', notifications.getSuccessNotification(`${attachment.name}`, 'The file was successfully uploaded'));
                    return post;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getErrorNotification(`Failed to post your comment.`, 'Retry in few second.'));
                    console.log(error)
                    throw error;
                }.bind(this));
        },

        createCompanyPostVote(context, payload) {
            let data = {
                vote: _get(payload, 'voteValue', 1),
            }

            return context.state.axios
                .post(`/workspace/company-posts/${_get(payload, 'companyPost.uuid', '')}/votes`, data, {})
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    if (error.response.status !== 409) {
                        context.commit('addNotification', notifications.getErrorNotification(`Failed to add your vote.`, 'Retry in few second.'));
                    }
                    throw error;
                }.bind(this));
            // .catch(function (error) {
            //         if (error.response) {
            //             // The request was made and the server responded with a status code
            //             // that falls out of the range of 2xx
            //             console.log(error.response.data);
            //             console.log(error.response.status);
            //             console.log(error.response.headers);
            //         } else if (error.request) {
            //             // The request was made but no response was received
            //             // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            //             // http.ClientRequest in node.js
            //             console.log(error.request);
            //         } else {
            //             // Something happened in setting up the request that triggered an Error
            //             console.log('Error', error.message);
            //         }
            //         console.log(error.config);
            //     });
        },

        loadAttachments(context, payload) {
            let workspace = _get(context.state.currentWorkspace, 'slug', null);
            let channel = _get(payload, 'channel.uuid', null);
            let company = _get(payload, 'company.id', null);
            let companies = _get(payload, 'companies', null);

            let filters = [];
            if (null !== workspace) {
                filters.push(`workspaceSlug=${workspace}`);
            }
            if (null !== channel) {
                filters.push(`channelUuid=${channel}`);
            } else {
                filters.push('exists[channel]=false');
            }
            if (null !== company) {
                filters.push(`companySlug=${company}`);
            } else if(null === companies) {
                filters.push('exists[company]=false');
            }else {
                filters = filters.concat(companies.map((id) => `companySlug[]=${id}`));
            }

            return context.state.axios
                .get('/workspace/attachments?' + filters.join('&'), {})
                .then(function (response) {
                    return response.data['hydra:member'];
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getLoadingError('Attachments'));
                    console.log(error)
                    throw error;
                });
        },

        createAttachment(context, payload) {
            let formData = new FormData()
            formData.append('file', payload.fileToUpload);
            formData.append('workspace', _get(context.state.currentWorkspace, 'slug', null));
            formData.append('channel', _get(payload, 'channel.uuid', null));
            formData.append('company', _get(payload, 'company.id', null));
            formData.append('visibility', _get(payload, 'visibility', 2));

            return context.state.axios
                .post('/workspace/attachments',
                    formData, {
                        header: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function (event) {
                            const percentCompleted = Math.round((event.loaded * 100) / event.total) || payload.lastValueCallback();
                            console.log('onUploadProgress', percentCompleted);
                            payload.uploadProgressCallback(percentCompleted);
                        }
                    }
                ).then(function (response) {
                    payload.uploadProgressCallback(100);
                    let attachments = response.data.attachments['hydra:member'];
                    let failUpload = response.data.failFilesUpload['hydra:member'];

                    for (const attachment of attachments) {
                        context.commit('addNotification', notifications.getSuccessNotification(`${attachment.name}`, 'The file was successfully uploaded'));
                    }
                    for (const failUploadElement of failUpload) {
                        context.commit('addNotification', notifications.getErrorNotification(`Fail to upload <span class="underline ">${failUploadElement.filename}</span>`, failUploadElement.reason));
                    }

                    return attachments.pop();
                }).catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getErrorNotification(`Failed to upload the file ${payload.fileToUpload.name}`));
                    console.log(error)
                    throw error
                }.bind(this));
        },

        createAttachmentDownload(context, payload) {
            const uuid = _get(payload, 'attachment.uuid', null);
            const expires = _get(payload, 'expires', 900)

            return context.state.axios
                .post(`/workspace/attachments/${uuid}/download`, {expires: expires}, {})
                .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getErrorNotification(`Failed to get the download link for ${payload.attachment.name}`));
                    console.log(error)
                    throw new Error('' + error.response.status)
                }.bind(this));
        },

        deleteAttachment(context, attachment) {
            return context.state.axios
                .delete('/workspace/attachments/' + attachment.uuid, {
                    validateStatus: function (status) {
                        return status >= 200 && status < 300 || status === 404;
                    },
                })
                .then(function (response) {
                    context.commit('addNotification', notifications.getSuccessNotification(`${attachment.name}`, 'The file was successfully removed'));
                })
                .catch(function (error) {
                    if(error !== null && error.response.status === 403) {
                        context.commit('addNotification', notifications.getErrorNotification(`${attachment.name}`, 'Your are not authorized to remove this attachment.'));
                        throw error
                    }

                    // TODO: Make error management
                    console.log(error)
                    context.commit('addNotification', notifications.getErrorNotification(`Failed to remove the file ${attachment.name}`));
                    console.log(error)
                    throw error
                });
        },


        retrieveCompanyNewsFor(context, payload) {
            const apiKey = '2ae8a610b3ec4e7d94dd515535da35fa';

            return context.state.axios
                .get(`https://newsapi.org/v2/everything?q=${encodeURI('"' + payload.companyName + '"')}&from=-30&sortBy=publishedAt&apiKey=${apiKey}`, {})
                .then(function (response) {
                    return _get(response.data, 'articles', []);
                }).catch(function (error) {
                    return [];
                });
        },


        createCompanyRejectVote(context, payload) {
            const data = {
                "workspace": context.state.currentWorkspace.slug,
                "originalChannel": _get(payload, 'channelUuid', null),
                "company": _get(payload, 'companySlug', null),
                "reviewer": _get(context.getters.getCurrentMemberProfile, 'uuid', null),
                "rejectTypeName": _get(payload, 'rejectTypeName', 'sineora.unknown'),
                "reason": _get(payload, 'reason', null),
                "additionalInformation": _get(payload, 'additionalInformation', null),
            };

            return context.state.axios
                .post(`/workspace/company-reject-votes`, data, {})
                .then(function (response) {
                    const workspace = response.data;
                }.bind(this))
                .catch(function (error) {
                    // TODO: Make error management
                    console.log(error)
                    throw error
                });
        },


        deleteCompanyRejectVote(context, payload) {
            const rejectVoteUuid = _get(payload, 'companyRejectVoteUuid');

            if (rejectVoteUuid === null && !'companySlug' in payload) {
                throw new Error('companyRejectVoteUuid or companySlug must be present in the payload');
            }

            if (rejectVoteUuid === null) {
                return context.state.axios
                    .delete('/workspace/company-reject-votes/', {
                        validateStatus: function (status) {
                            return status >= 200 && status < 300 || status === 404;
                        },
                        data: {
                            workspace: context.state.currentWorkspace.slug,
                            originalChannel: _get(payload, 'channelUuid', null),
                            company: _get(payload, 'companySlug', null),
                            reviewer: _get(context.getters.getCurrentMemberProfile(), 'uuid', null),
                        }
                    })
                    .catch(function (error) {
                        // TODO: Make error management
                        console.log(error)
                        throw error
                    });
            }

            return context.state.axios
                .delete(`/workspace/company-reject-votes/${rejectVoteUuid}`, {
                    validateStatus: function (status) {
                        return status >= 200 && status < 300 || status === 404;
                    },
                })
                .catch(function (error) {
                    // TODO: Make error management
                    console.log(error)
                    throw error
                });
        },


        retrieveGlobalNotifications(context, payload) {
            return context.state.axios
                .get('/notifications?seen=false', {})
                .then(function (response) {
                    context.commit('setGlobalNotifications', response.data['hydra:member']);
                    return response.data['hydra:member'];
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getLoadingError('Notifications'));
                    console.log(error)
                    throw error;
                });
        },

        editGlobalNotification(context, payload) {
            const notification = _get(payload, 'notification', null);
            const notificationToken = _get(notification, 'token', null);

            if (notification === null || notificationToken === null) {
                context.commit('addNotification', notifications.getErrorNotification('Action not completed', 'Some data are missing.'));
                throw new Error();
            }

            const data = {
                "seen": _get(notification, 'seen', true),
            };

            return context.state.axios
                .patch(`/notifications/${notificationToken}`, data, {
                    headers: {
                        'Content-Type': 'application/merge-patch+json'
                    }
                })
                .then(function (response) {
                    return response.data;
                }.bind(this))
                .catch(function (error) {
                    // TODO: Make error management
                    console.log(error)
                    throw error
                });
        },



        renameChannel(context, data) {
            const enrichedData = {
                ...data,
                noNotification: true,
            };
            context
                .dispatch("editChannel", enrichedData)
                .then(() => context.commit('addNotification', _get(enrichedData, 'notification', notifications.getEditedChannelNotification(enrichedData.label))));
        },

        editChannel(context, data) {
            const noNotification = _get(data, 'noNotification', false);
            let channel = context.state.detailedChannels[context.state.channelNameUuidMappings[data.channelUuid]];
            let channelData = {
                label: _get(data, 'label', channel.label),
                description: _get(data, 'description', channel.description),
                sortOrder: _get(data, 'sortOrder', channel.sortOrder),
                counters: _get(data, 'counters', channel.counters),
                archived: _get(data, 'archived', channel.archived),
            };

            return context.state.axios
                .put('/channels/' + data.channelUuid, channelData, {})
                .then(function (response) {
                    context.commit('setDetailedChannel', response.data);
                    if (!noNotification) {
                        context.commit('addNotification', _get(data, 'notification', notifications.getEditedChannelNotification(channelData.label)));
                    }
                    return response.data;
                })
                .catch(function (error) {
                    // TODO: Make error management
                    context.commit('addNotification', notifications.getEditedChannelErrorNotification(channelData.label));
                    console.log(error)
                    throw error;
                });
        },

        fakerCreateAttachment(context, payload) {
            const promise = new Promise(function (resolutionFunc, rejectionFunc) {
                setTimeout(() => {
                    resolutionFunc(Math.floor(Math.random() * (50 - 1) + 1));
                }, Math.floor(Math.random() * (2000 - 500) + 500));
            });

            return promise.then(function (n) {
                payload.uploadProgressCallback(n);

                return new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        resolve(Math.floor(Math.random() * ((100 - n) - (n + 1)) + (n + 1)));
                    }, Math.floor(Math.random() * (2000 - 500) + 500));
                });
            }).then(function (n) {
                payload.uploadProgressCallback(n);
                return new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        resolve(
                            {
                                "@context": "string",
                                "@id": "string",
                                "@type": "string",
                                "uuid": "2",
                                "workspace": "1",
                                "company": "1",
                                "bytes": payload.fileToUpload.size,
                                "member": "Me",
                                "uploaded": true,
                                "mimeType": "application/pdf",
                                "name": payload.fileToUpload.name,
                                "url": "https://upload.sineora.com/doc/" + payload.fileToUpload.name,
                                "extension": "pdf",
                                "thumbnailSmall": "string",
                                "thumbnailMedium": "string",
                                "thumbnailLarge": "string",
                                "active": true,
                                "inactive": false,
                                "activeUpdatedAt": "2022-02-03T12:12:27.858Z",
                                "createdAt": new Date().toUTCString(),
                                "updatedAt": "2022-02-03T12:12:27.858Z",
                            });
                    }, Math.floor(Math.random() * (2000 - 500) + 500));
                });
            });
        },

    },
});

export default store;